import { NgModule } from '@angular/core';
import { ImgEnlargementComponent } from './img-enlargement.component';

@NgModule({
    declarations: [
        ImgEnlargementComponent
    ],
    imports: [],
    exports: [
        ImgEnlargementComponent
    ]
})
export class NcImgEnlargementModule { }